var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJcb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "299px",
    height: "231px",
    viewBox: "0 0 299 231",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "jcb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-57.5270968%",
    y1: "50.1241953%",
    x2: "232.39121%",
    y2: "50.1241953%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00873F",
    offset: "22.85%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40A737",
    offset: "74.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB531",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.182516704%",
    y1: "49.95997%",
    x2: "100.273441%",
    y2: "49.95997%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00873F",
    offset: "22.85%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40A737",
    offset: "74.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB531",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-62.8015845%",
    y1: "49.8578253%",
    x2: "253.671294%",
    y2: "49.8578253%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00873F",
    offset: "22.85%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40A737",
    offset: "74.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB531",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.175556793%",
    y1: "50.0058048%",
    x2: "101.808162%",
    y2: "50.0058048%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004E94",
    offset: "47.51%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066B1",
    offset: "82.61%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FBC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.575855512%",
    y1: "49.9142191%",
    x2: "98.13299%",
    y2: "49.9142191%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#882730",
    offset: "17.35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE1833",
    offset: "57.31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC0436",
    offset: "85.85%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60039",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "jcb",
    transform: "translate(0.842519, 0.692920)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298,183.2445 C298,208.745722 277.23472,229.511003 251.733497,229.511003 L0,229.511003 L0,46.2665039 C0,20.7652813 20.7652813,0 46.2665039,0 L298,0 L298,183.2445 Z",
    id: "path6325",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6327",
    transform: "translate(199.638143, 15.482885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3936431,120.766504 L35.51956,120.766504 C36.0660148,120.766504 37.3410759,120.584353 37.8875307,120.584353 C41.5305625,119.855746 44.6271395,116.577018 44.6271395,112.023228 C44.6271395,107.65159 41.5305625,104.372861 37.8875307,103.462103 C37.3410759,103.279952 36.2481664,103.279952 35.51956,103.279952 L16.3936431,103.279952 L16.3936431,120.766504 Z",
    id: "path6338",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.333741,0 C15.118582,0 0.18215159,14.7542788 0.18215159,33.1515894 L0.18215159,67.5782399 L46.9951102,67.5782399 C48.0880198,67.5782399 49.3630809,67.5782399 50.2738388,67.7603915 C60.8386311,68.3068463 68.6711494,73.771394 68.6711494,83.2432766 C68.6711494,90.7114918 63.3887533,97.0867975 53.5525675,98.3618586 L53.5525675,98.7261618 C64.2995113,99.4547681 72.4963328,105.465771 72.4963328,114.755502 C72.4963328,124.773839 63.3887533,131.331296 51.3667484,131.331296 L-5.17705956e-14,131.331296 L-5.17705956e-14,198.727385 L48.6344745,198.727385 C66.8496335,198.727385 81.7860639,183.973106 81.7860639,165.575795 L81.7860639,0 L33.333741,0 Z",
    id: "path6349",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2591689,85.4290957 C42.2591689,81.0574576 39.1625918,78.1430321 35.51956,77.5965773 C35.1552569,77.5965773 34.2444989,77.4144258 33.6980441,77.4144258 L16.3936431,77.4144258 L16.3936431,93.4437657 L33.6980441,93.4437657 C34.2444989,93.4437657 35.3374085,93.4437657 35.51956,93.2616141 C39.1625918,92.7151593 42.2591689,89.8007339 42.2591689,85.4290957 L42.2591689,85.4290957 Z",
    id: "path6360",
    fill: "url(#linearGradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.7273841,15.4828851 C31.5122251,15.4828851 16.5757947,30.2371639 16.5757947,48.6344745 L16.5757947,130.420538 C25.8655258,134.974328 35.51956,137.888754 45.1735943,137.888754 C56.6491445,137.888754 62.8422986,130.966993 62.8422986,121.495111 L62.8422986,82.8789734 L91.2579466,82.8789734 L91.2579466,121.312959 C91.2579466,136.249389 81.9682155,148.453546 50.4559904,148.453546 C31.3300735,148.453546 16.3936431,144.264059 16.3936431,144.264059 L16.3936431,214.028118 L65.0281176,214.028118 C83.2432766,214.028118 98.179707,199.273839 98.179707,180.876529 L98.179707,15.4828851 L49.7273841,15.4828851 Z",
    id: "path6371",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.349634,15.4828852 C123.134475,15.4828852 108.198044,30.2371639 108.198044,48.6344745 L108.198044,91.986553 C116.577018,84.8826409 131.149145,80.3288512 154.6467,81.4217607 C167.21516,81.9682155 180.694377,85.4290957 180.694377,85.4290957 L180.694377,99.4547681 C173.954768,95.9938879 165.940098,92.8973109 155.557458,92.1687045 C137.706602,90.8936434 126.959658,99.6369197 126.959658,114.937653 C126.959658,130.420538 137.706602,139.163815 155.557458,137.706602 C165.940098,136.977996 173.954768,133.699267 180.694377,130.420538 L180.694377,144.446211 C180.694377,144.446211 167.397311,147.907091 154.6467,148.453546 C131.149145,149.546455 116.577018,144.992666 108.198044,137.888754 L108.198044,214.392421 L156.832519,214.392421 C175.047678,214.392421 189.984108,199.638143 189.984108,181.240832 L189.984108,15.4828852 L141.349634,15.4828852 Z",
    id: "path6384",
    fill: "url(#linearGradient-5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.4c3acd852c0932a4b74ad13346f0accb.svg";
export { ForwardRef as ReactComponent };